import { Box } from "@mui/material";

const StatusIndicator = ({ status }: { status: boolean }) => {
  const activeColor = "rgba(46, 204, 113, 1)"; // green
  const inactiveColor = "rgba(231, 76, 60, 1)"; // red

  return (
    <Box
      sx={{
        width: 14,
        height: 14,
        borderRadius: "50%",
        backgroundColor: status ? "success.main" : "error.main",
        boxShadow: status
          ? `0 0 8px ${activeColor}`
          : `0 0 8px ${inactiveColor}`,
        animation: status ? "pulse 1.5s ease-in-out infinite" : "none",
        "@keyframes pulse": {
          "0%": {
            boxShadow: `0 0 6px ${activeColor}`,
          },
          "50%": {
            boxShadow: `0 0 14px ${activeColor}`,
          },
          "100%": {
            boxShadow: `0 0 6px ${activeColor}`,
          },
        },
      }}
    />
  );
};

export default StatusIndicator;
